/*
 * @Author: YuanYuan
 * @Date: 2025-12-05 15:15:00
 * @LastEditTime: 2025-12-05 15:15:43
 * @Description: 套餐管理
 */
const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'tableQuery',
    path: `${prefix}/package/getUserPackage`,
    method: 'get',
    params: {
      page: 1,
      limit: 10,
      startTime: '',
      endTime: '',
      packageId: ''
    },
    desc: '套餐管理-套餐列表'
  },
  {
    name: 'changeAutoRenew',
    path: `${prefix}/package/changeAutoRenew`,
    method: 'post',
    params: {
      packageId: '',
      autoRenew: ''
    },
    desc: '套餐相关-修改自动续费'
  },
  {
    name: 'checkPackageOrder',
    path: `${prefix}/order/packageExistOrder`,
    method: 'get',
    params: {
      packageId: ''
    },
    desc: '判断是否可以升级或续费'
  }
]
